import { render, staticRenderFns } from "./reset-password-container.vue?vue&type=template&id=4273cd68"
import script from "./reset-password-container.vue?vue&type=script&lang=js"
export * from "./reset-password-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4273cd68')) {
      api.createRecord('4273cd68', component.options)
    } else {
      api.reload('4273cd68', component.options)
    }
    module.hot.accept("./reset-password-container.vue?vue&type=template&id=4273cd68", function () {
      api.rerender('4273cd68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/login/components/reset-password-container.vue"
export default component.exports